import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ILessonVideoLogs } from '@/Module/Lesson/Model/ApiModel';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
import { LessonService } from '@/Module/Lesson/Service';

interface IRequest {
  videoId: ILessonSection['lessonVideoId'];
  accessToken: string;
}

export const getLessonPlayedPercentageAction = createAsyncThunk<ILessonVideoLogs, IRequest>(
  'lesson/getWatchedPercentage',
  async ({ videoId, accessToken }, { signal }) => {
    const token = `Bearer ${accessToken}`;
    return LessonService.getLessonVideoLogs(videoId, token, signal).then(({ data: { data } }) => data);
  },
);
